import usePageMeta from '@/hooks/usePageMeta';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SecurityHero from './components/SecurityHero';
import SecurityContent from './components/SecurityContent';

const SecurityPage = () => {
  usePageMeta({
    title: '情報セキュリティ基本方針 | 株式会社MSK',
    ogTitle: '情報セキュリティ基本方針 | 株式会社MSK',
    description: '株式会社MSKの情報セキュリティに関する基本方針をご紹介いたします。',
  });

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      <main>
        <SecurityHero />
        <SecurityContent />
      </main>
      <Footer />
    </div>
  );
};

export default SecurityPage;